import React, { useEffect, useState } from "react";
import "./MessageCodes.css";

const MessageA81 = (props) => {
  const [onClick , setOnClick] = useState(false)

  useEffect(()=>{
    !props?.disableButtons && props?.setLitmusFeedback(props?.item?.data)
  },[])
  return (
    <>
 
    </>
  );
};

export default MessageA81;
